import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, finalize, Observable } from 'rxjs';
import { HttpOptions } from '../model/http-options.model';
import { OrganizationService } from '../services/organization.service';
import { Organization } from '../model/organization/organization.model';

@Injectable({
  providedIn: 'root',
})
export class AppStateStore {
  /**
   * Dependencies
   */
  private readonly organizationService = inject(OrganizationService);
  // API
  private organizationListSubject = new BehaviorSubject<Organization[]>([]);
  public organizationList$: Observable<Organization[]> = this.organizationListSubject.asObservable();
  // Loading
  private loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public readonly loading$: Observable<boolean> = this.loadingSubject.asObservable();

  public loadOrganizationListData(options?: HttpOptions): void {
    this.loadingSubject.next(true);
    this.organizationService.overview(options).subscribe(
      (organizationList: Organization[]): void => {
        this.organizationListSubject.next(organizationList);
        // Mark loading as finished
        this.loadingSubject.next(false);
      },
    );
  }

  public loadOrganizationById(organizationId: string): Observable<Organization> {
    setTimeout(() => this.loadingSubject.next(true), 0);
    return this.organizationService.getOrganizationById(organizationId)
      .pipe(
        // Mark loading as finished
        finalize(() => setTimeout(() => this.loadingSubject.next(false), 0)),
      );
  }

  public loadOrganizationBySlug(slug: string): Observable<Organization> {
    setTimeout(() => this.loadingSubject.next(true), 0);
    return this.organizationService.getOrganizationBySlug(slug)
      .pipe(
        // Mark loading as finished
        finalize(() => setTimeout(() => this.loadingSubject.next(false), 0)),
      );
  }
}
